import { render, staticRenderFns } from "./smt_sh.vue?vue&type=template&id=2563dcf1"
import script from "./smt_sh.vue?vue&type=script&lang=js"
export * from "./smt_sh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports